



import React, { useState, useEffect } from 'react';
import Navbar from '../inc/Navbar';
import AddToCartButton from './AddToCart';
import { SubmitForm } from './submit'

// import PaginationOld from './PaginationOld';
import './Agriculture.css';
import { Link } from 'react-router-dom';
import ScrollToTop from "react-scroll-to-top";
import ReactWhatsapp from "react-whatsapp";

import { collection, getDocs, } from "firebase/firestore";
import { db } from '../../firebase'
import { useUserAuth } from '../../contexts/UserAuthContext'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'
import AddBook from '../AddBook';



firebase.initializeApp({
  apiKey: "AIzaSyDaTbOJkxcyn_XwPlup2ZicYKtqBtRwpY0",
  authDomain: "lipo-kart.firebaseapp.com",
  projectId: "lipo-kart",
  storageBucket: "lipo-kart.firebasestorage.app",
  messagingSenderId: "568534822854",
  appId: "1:568534822854:web:803cafde94ca350bbeccc7",
  measurementId: "G-J147CD0ZTK"
})
const auth1 = firebase.auth()
const firestore = firebase.firestore()


function HerbalSyrup(props) {

  const [showPerPage, setShowPerPage] = useState(251);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPerPage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const [searchTerm, setsearchTerm] = useState("");
  const [garments, setGarments] = useState([])
  const garmentRef = collection(db, "Herbal Syrup")
  const [cartItemCount, setCartItemCount] = useState(1);


  const [checkups, setCheckups] = useState([])
  const checkup1Ref = collection(db, "Checkups")


  const addToCart = () => {
    setCartItemCount(cartItemCount + 1);
  };
  const bookingDetails = (bookings) => {
    console.log(bookings)
  }
  const removeFromCart = () => {
    if (cartItemCount > 0) {
      setCartItemCount(cartItemCount - 1);
    }
  };
  useEffect(() => {
    const getgarments = async () => {
      const data = await getDocs(garmentRef);
      setGarments(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    }
    getgarments()
  }, [])
  const {
    state: { cart },
    dispatch,
  } = useUserAuth();

  useEffect(() => {
    const getcheckups = async () => {
      const data = await getDocs(checkup1Ref);
      setCheckups(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    }
    getcheckups()
  }, [])

 

  return (
    <div >

      <Navbar />
      <br />
      <br />
      <br />
     

      <ScrollToTop smooth top="100" color="Darkblue" />



      <br></br>
      <div className='colorback'>
        <div className="album py-1">

          <div className="container mt-3">

            <div className="row">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li style={{ color: "Darkblue" }} className="breadcrumb-item"><Link style={{ color: "Darkblue" }} to="/" > HOME</Link></li>


                  <li className="breadcrumb-item active" aria-current="page">HERBAL SYRUP</li>

                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div className="album py-1">

        <div className="container">

          <div className="row">
            <div className="col-md-4">

              <div className="card-body">
                <input type="text" class="form-control" placeholder="Search..." name="location"
                  onChange={(e) => {
                    setsearchTerm(e.target.value);
                  }}
                />
                <div className="d-flex justify-content-between align-items-center">




                </div>


              </div>


            </div>


          </div>
        </div>
      </div>

      <div className="album py-2">

        <div className="container">

          <div class="row">
            {garments.filter((val) => {
              if (setsearchTerm === "") {
                return val;
              } else if (
                val.name.toLowerCase().includes(searchTerm.toLowerCase())

              ) {
                return val;
              }
            }).slice(pagination.start, pagination.end).map((labtest) => {
              return (
                <div className="col-md-4" key={labtest.id}>

                  <div className="card  mb-4 border-dark box shadow ">
                    <img src={labtest.img} alt={labtest.name} />
                    <div className="card-body">
                      <h5 style={{ color: "maroon" }} className="card-text">{labtest.name}</h5>
                      <p className="card-text mb-1">{labtest.detail}</p>
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="card-text mb-2"> Size: {labtest.size}  </p>
                        <p style={{ color: "Darkblue" }} className="card-text mb-2"> <del>{labtest.nosize} </del> </p>
                      </div>
                      <p className="card-text"> <b>Color:</b> {labtest.color} </p>
                      <p style={{ color: "Gray" }} className="card-text mb-2"> M.R.P.: <del> ₹{labtest.mrp}</del> </p>
                      <button className='btn btn-outline-danger btn-sm mb-2'>{labtest.off} %OFF</button>
                      <h6 className="card-text" >₹ {labtest.price}   </h6>
                      {/* <h6 className="card-text" >ADD TO CART</h6> */}
                      {/* <h6 className="card-text" >{labtest.type}</h6> */}
                      <div className="d-flex justify-content-between align-items-center">
                        {cart.some((p) => p.id === labtest.id) ? (
                          <div className="App">
                            <AddToCartButton
                              itemCount={cartItemCount}
                              onIncrement={addToCart}
                              onDecrement={removeFromCart}
                              bookingData={labtest}

                            />
                            <br />
                            <div><SubmitForm
                              itemCount={cartItemCount}
                              bookingData={labtest}
                            />
                            </div>
                          </div>

                          // <button onClick={() =>
                          //   dispatch({
                          //     type: "REMOVE_FROM_CART",
                          //     payload: labtest,
                          //   })
                          // } className='btn btn-danger brn-sm'>Remove</button>
                        ) : (

                          <button onClick={() =>
                            dispatch({
                              type: "ADD_TO_CART",
                              payload: labtest,
                            })

                          } class="btn btn-primary btn-sm">ADD TO CART</button>
                        )}

<a className='callbutton mb-2' href='tel: 8101286812'>Call Now</a>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center">

                                                <ReactWhatsapp number="+91 8101286812" className="whatsappcolor" message="I am Interested"> WhatsApp Book</ReactWhatsapp>

                                                <button type="button" className="lipokartproducts" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                                    Enquiry
                                                </button>


                                                <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                    <div className="modal-dialog">
                                                        <div className="modal-content">
                                                            <div className="modal-header">

                                                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                                            </div>
                                                            <div className="modal-body">
                                                                <AddBook />
                                                            </div>
                                                            <div className="modal-footer">
                                                                <button type="button" className="whatsappcolor" data-bs-dismiss="modal">Close</button>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                    </div>
                  </div>
                </div>

              )
            })}

          </div>
          {/* <PaginationOld showPerPage={showPerPage}
            onPaginationChange={onPaginationChange}
            total={garments.length}
          /> */}
        </div>

      </div>




      {/* <div className="test2">
  <div className="card text-center" >
  <div className="card-body">
  <img src={Fever} class="card-img-top rounded-circle "alt="Fever"/>
  <br></br>
    <button type="button" class="btn btn-outline-primary">Fever</button>
    </div>
  </div>
</div> */}




      {/* 
      <div className="album py-1">

        <div className="container">

        </div>
      </div> */}



      {/* <Checkup /> */}
      <br></br>






    </div>







  );
}

export default HerbalSyrup;